import { Component } from '@angular/core';
import { CampaignService } from './campaign.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'del-trust';
  expand=false;
 // current_page="aboutus"
	constructor(public CS: CampaignService) { 
		//this.CS.updateContent();
	}

	
  toggleHeader(){
	  this.expand=!this.expand;
	}
}
